export const transferLabel = (
  direction: 'in' | 'out',
  counterpartyName: string
): string =>
  direction === 'in'
    ? `Transferred in from ${counterpartyName}`
    : `Transferred out to ${counterpartyName}`;
